<!--多行文本-->
<template>
  <div class="item-box">
    <div :class="['question-item-title title',{isMbottom:question.show_rule.is_check_show}]">
      <span :class="{xinxin:isYes}">
        <i v-if="!$store.state.settingData.base.notorder">{{ number }}、</i>
        <span class="title-type" v-if="$store.state.formType === 2 || $store.state.formType === 3">{{question.subtype}}</span><span class="q-title" v-html="question.title"></span>
        <span class="fenshu" v-if="$store.state.formType === 2 || $store.state.formType === 3">(分值：{{question.score}}分)</span>
        <Icon type="ios-information-circle" @click="hintShowClick" v-if="$store.state.formType === 1 && question.show_rule.is_check_show && question.show_rule.hint.length>0"/>
      </span>
    </div>
    <span class="title-tips" v-html="question.show_rule.hint" v-if="$store.state.formType === 1 && !question.show_rule.is_check_show"></span>
    <div class="item">
      <Input v-model="tTextAreaValue"
             @on-blur="inputBlur"
             type="textarea"
             :autosize="{minRows: 4}"
             :style="question.show_rule.input_width"
             v-if="!isAnalysis"></Input>
      <p class="analysisText" v-if="isAnalysis"><span>考生答案：</span>{{question.my_answer}}</p>
      <p class="daAnTrueText" v-if="isAnalysis"><span>正确答案：</span>{{question.answer}}</p>
    </div>
    <!--提示弹框-->
    <Modal class="hintModel" v-model="modal" width="70%" :closable="false">
      <p slot="header">
        <Icon type="ios-information-circle"></Icon>
        <span>填写提示</span>
      </p>
      <div style="color: #4e4c56;font-size: 16px">
        <span v-html="question.show_rule.hint"></span>
      </div>
      <div slot="footer">
        <p @click="clearClick">我知道了</p>
      </div>
    </Modal>
  </div>
</template>

<script>
    export default {
        name: "tTextArea",
        props: {
            question: {
                type: Object,
                default() {
                    return {}
                }
            },
            number: {
                type: Number,
                default() {
                    return 1;
                }
            },
            isAnalysis: {
                type: Boolean,
                default() {
                    return false
                }
            }
        },
        data() {
            return {
                tTextAreaValue: '',
                isYes: false,
                modal: false
            }
        },
        mounted() {
            this.tTextAreaValue = this.$store.state.user_answers[this.question.id]
            this.question.verify_rule !== null ? this.isYes = this.question.verify_rule.is_require : this.isYes = false
        },
        methods: {
            inputBlur() {
                let obj = {}
                obj[this.question.id] = this.tTextAreaValue
                this.$store.dispatch('userAnswersActions', obj)
            },
            hintShowClick() {
                this.modal = true
            },
            clearClick() {
                this.modal = false
            }
        },
        watch: {
            question: {
                handler(newValue, oldValue) {
                    this.question = newValue
                    this.tTextAreaValue = this.$store.state.user_answers[this.question.id]
                    this.question.verify_rule !== null ? this.isYes = this.question.verify_rule.is_require : this.isYes = false
                },
                deep: true
            },
            number: {
                handler(newValue, oldValue) {
                    this.number = newValue
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>

  .xinxin {
    position: relative;
    margin-right: 5px;
    padding-left:8px;
    &:after {
      content: "*";
      display: inline-block;
      margin-right: 4px;
      font-size: 16px;
      color: rgb(255, 51, 0);
      position: absolute;
      top: 0px;
      left: 0px;
    }
  }

  .title-type {
    color: #0D5EFF;
    font-size: 14px;
    background-color: #E6EDF9;
    border-radius: 4px;
    padding: 4px 5px;
    font-weight: 500;
    margin-right: 6px;
  }

  .fenshu {
    color: #cc5252;
    margin-left: 5px;
  }

  .item {
    margin-top: 22px;

    /deep/ .ivu-input {
      font-size: 12px;
    }

    .analysisText {
      font-size: 14px;
      font-weight: 400;
      color: #303133;
      line-height: 27px;
      padding-top: 10px;
      margin-bottom: 5px;

      span {
        color: #909399;
      }
    }

    .daAnTrueText {
      font-size: 14px;
      color: #303133;
      font-weight: 400;

      span {
        color: #909399;
      }
    }
  }


  .analysisText {
    font-size: 14px;
    font-weight: 400;
    color: #909399;
    line-height: 27px;
    padding-top: 20px;
  }
</style>
